import type { HTMLAttributes } from "react";
import { cn } from "@/lib/utils";

type Tone = "active" | "pending" | "cancelled" | "neutral";

const tones: Record<Tone, string> = {
  active: "bg-accent/15 text-accent-light border-accent-subtle",
  pending: "bg-warning/15 text-warning border-warning/40",
  cancelled: "bg-danger/15 text-danger border-danger/40",
  neutral: "bg-bg-tertiary text-text-secondary border-accent-subtle",
};

export function Badge({
  tone = "neutral",
  className,
  ...props
}: HTMLAttributes<HTMLSpanElement> & { tone?: Tone }) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-pill border px-2.5 py-0.5 text-xs font-medium",
        tones[tone],
        className,
      )}
      {...props}
    />
  );
}
